import React, { Children, useLayoutEffect, useCallback, useState } from "react";
import propTypes from "prop-types";

export default function Carousel({ children, refContainer }) {
  const [index, setIndex] = useState(0);
  const containerClientRect = refContainer.current.getBoundingClientRect();
  const refDragHandler = React.useRef();

  const threshold = 100;
  const itemToShow = window.innerWidth < 767 ? 1 : 4;
  const DIRECTION_LEFT = "DIRECTION_LEFT";
  const DIRECTION_RIGHT = "DIRECTION_RIGHT";

  const posInitial = React.useRef();
  const posX1 = React.useRef();
  const posX2 = React.useRef();
  const posFinal = React.useRef();
  const isAllowShift = React.useRef(true);
  const cards = React.useRef();
  const cardCount = cards.current?.length || 0;
  const cardSize = cards.current?.[0]?.offsetWidth || 0;

  const fnCheckIndex = useCallback(
    (event) => {
      if (event.propertyName === "left") {
        setTimeout(() => {
          refDragHandler.current.classList.remove("transition-all");
          refDragHandler.current.classList.remove("duration-200");
        }, 200);

        const isMobile = window.innerWidth < 767 ? 0 : -1;
        if (index <= 0) {
          refDragHandler.current.style.left = 0 + "px";
          setIndex(0);
        } else if (index >= cardCount - itemToShow) {
          refDragHandler.current.style.left =
            -((cardCount - itemToShow + isMobile) * cardSize) + "px";
          setIndex(cardCount - itemToShow);
        } else if (index === cardCount || index === cardCount - 1) {
          refDragHandler.current.style.left = (cardCount - 1) * cardSize + "px";
          setIndex(cardCount - 1);
        }

        isAllowShift.current = true;
      }
    },
    [cardCount, cardSize, index, itemToShow]
  );

  const fnShiftItem = useCallback(
    (direction) => {
      refDragHandler.current.classList.add("transition-all");
      refDragHandler.current.classList.add("duration-200");
      //   setIsAnimated(true);

      if (isAllowShift.current) {
        if (direction === "DIRECTION_LEFT") {
          setIndex((prev) => prev + 1);
          refDragHandler.current.style.left =
            posInitial.current - cardSize + "px";
        } else if (direction === "DIRECTION_RIGHT") {
          setIndex((prev) => prev - 1);
          refDragHandler.current.style.left =
            posInitial.current + cardSize + "px";
        }
      }

      isAllowShift.current = false;
    },
    [cardSize]
  );

  const onDragMove = useCallback(
    (event) => {
      const e = event || window.event;
      e.preventDefault();

      if (e.type === "touchmove") {
        posX2.current = posX1.current - e.touches[0].clientX;
        posX1.current = e.touches[0].clientX;
      } else {
        posX2.current = posX1.current - e.clientX;
        posX1.current = e.clientX;
      }
      refDragHandler.current.style.left =
        refDragHandler.current.offsetLeft - posX2.current + "px";
    },
    [posX1, posX2]
  );

  const onDragEnd = useCallback(
    (event) => {
      const e = event || window.event;
      e.preventDefault();

      posFinal.current = refDragHandler.current.offsetLeft;

      if (posFinal.current - posInitial.current < -threshold) {
        //   console.log(
        //     "Shift Slide to Right",
        //     posFinal.current - posInitial.current
        //   );
        fnShiftItem(DIRECTION_LEFT);
      } else if (posFinal.current - posInitial.current > threshold) {
        //   console.log("Shift Slide to Left", posFinal.current - posInitial.current);
        fnShiftItem(DIRECTION_RIGHT);
      } else {
        refDragHandler.current.style.left = posInitial.current + "px";
      }

      document.onmouseup = null;
      document.onmousemove = null;
    },
    [fnShiftItem]
  );

  const onDragStart = useCallback(
    (event) => {
      const e = event || window.event;
      e.preventDefault();

      posInitial.current = refDragHandler.current.offsetLeft;

      if (e.type === "touchstart") {
        posX1.current = e.touches[0].clientX;
      } else {
        posX1.current = e.clientX;
        document.onmouseup = onDragEnd;
        document.onmousemove = onDragMove;
      }
    },
    [onDragMove, onDragEnd]
  );

  const onClick = (event) => {
    const e = event || window.event;
    !isAllowShift.current && e.preventDefault();
  };

  //   const fnDragAction = (event) => {
  //     const e = event || window.event;
  //     e.preventDefault();
  //   }

  useLayoutEffect(() => {
    const refForwardDragHandler = refDragHandler.current;

    refForwardDragHandler.onmousedown = onDragStart;

    refForwardDragHandler.addEventListener("touchstart", onDragStart);
    refForwardDragHandler.addEventListener("touchend", onDragEnd);
    refForwardDragHandler.addEventListener("touchmove", onDragMove);
    refForwardDragHandler.addEventListener("transitionend", fnCheckIndex);
    refForwardDragHandler.addEventListener("click", onClick);
    return () => {
      refForwardDragHandler.removeEventListener("touchstart", onDragStart);
      refForwardDragHandler.removeEventListener("touchend", onDragEnd);
      refForwardDragHandler.removeEventListener("touchmove", onDragMove);
      refForwardDragHandler.removeEventListener("transitionend", fnCheckIndex);
      refForwardDragHandler.removeEventListener("click", onClick);
    };
  }, [onDragMove, onDragStart, onDragEnd, fnCheckIndex]);

  useLayoutEffect(() => {
    if (refDragHandler.current) {
      cards.current = refDragHandler.current?.getElementsByClassName("card");
    }
  }, []);

  //   - cards?.current?.[0]
  //             ? +window
  //                 .getComputedStyle(cards?.current?.[0])
  //                 ?.paddingLeft.replace("px", "")
  //             : 0,

  return (
    <div
      ref={refDragHandler}
      className={["flex -mx-4 flex-row relative"].join(" ")}
      style={{
        paddingLeft: containerClientRect.left - 16,
      }}
    >
      {Children.toArray(children)}
    </div>
  );
}

Carousel.propTypes = {
  refContainer: propTypes.object,
};
